import { ref, watch, computed } from '@vue/composition-api'
import store from '@/store'
import i18n from '@/libs/i18n'
import { title } from '@core/utils/filter'

// Notification
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default function useFuellingList() { 
  // Use toast
  const toast = useToast()

  const refFuellingListTable = ref(null)  

  // Table Handlers
  const tableColumns = [
    { key: 'plate', sortable: false , label: i18n.t('Identifier')},
    { key: 'dateTime', sortable: false , label: i18n.t('Date')},
    { key: 'liters', sortable: false , label: i18n.t('Liters')},
    { key: 'value', sortable: false },
    { key: 'odometer', sortable: false },
    { key: 'hourmeter', sortable: false },
    //{ key: 'customerName', sortable: true },
    { key: 'actions' },
  ]

  /*
  "id": "fe75d0be-9a40-488b-962a-dffaa7161479",
      "name": "adm",
      "user": "adm",
      "email": "adm@testtracking.com",
      "customerName": "Test Tracker Company"
  */ 

  const perPage = ref(10)
  const totalFuelling = ref(0)
  const currentPage = ref(1)
  const perPageOptions = [10, 25, 50, 100]
  const searchQuery = ref('')
  const sortBy = ref('id')
  const isSortDirDesc = ref(true)
  const dateStart = ref('')
  const dateEnd = ref('')
  const assetId = ref('')
  

  //const roleFilter = ref(null)
  //const planFilter = ref(null)
  //const statusFilter = ref(null)

  const dataMeta = computed(() => {
    const localItemsCount = refFuellingListTable.value ? refFuellingListTable.value.localItems.length : 0
    return {
      from: perPage.value * (currentPage.value - 1) + (localItemsCount ? 1 : 0),
      to: perPage.value * (currentPage.value - 1) + localItemsCount,
      of: totalFuelling.value,
    }
  })

  const refetchData = () => {
    refFuellingListTable.value.refresh()
  }

  watch([currentPage, perPage, searchQuery,dateStart, dateEnd, assetId], () => {
    refetchData()
  })

  const fetchAllFuelling = (ctx, callback) => {
    store
      .dispatch('app-management/fetchAllFuelling', {
        q: searchQuery.value,
        perPage: perPage.value,
        page: currentPage.value,
        sortBy: sortBy.value,
        sortDesc: isSortDirDesc.value,
        assetId:assetId.value,
        dtS:dateStart.value,
        dtE:dateEnd.value
        //role: roleFilter.value,
        //plan: planFilter.value,
        //status: statusFilter.value,
      })
      .then(response => {
        const fuelling = response.data.data;
        const total = response.data.length;
        callback(fuelling)
        totalFuelling.value = response.data.totalItems
      })
      .catch(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: i18n.t('Error fetching fuelling list'),
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      })
  }

  // *===============================================---*
  // *--------- UI ---------------------------------------*
  // *===============================================---*

  const resolveUserRoleVariant = role => {
    if (role === 'subscriber') return 'primary'
    if (role === 'author') return 'warning'
    if (role === 'maintainer') return 'success'
    if (role === 'editor') return 'info'
    if (role === 'admin') return 'danger'
    return 'primary'
  }

  const resolveUserRoleIcon = role => {
    if (role === 'subscriber') return 'UserIcon'
    if (role === 'author') return 'SettingsIcon'
    if (role === 'maintainer') return 'DatabaseIcon'
    if (role === 'editor') return 'Edit2Icon'
    if (role === 'admin') return 'ServerIcon'
    return 'UserIcon'
  }

  const resolveUserStatusVariant = status => {
    if (status === 'pending') return 'warning'
    if (status === 'active') return 'success'
    if (status === 'inactive') return 'secondary'
    return 'primary'
  }

  return {
    fetchAllFuelling,
    tableColumns,
    perPage,
    currentPage,
    totalFuelling,
    dataMeta,
    perPageOptions,
    searchQuery,
    sortBy,
    isSortDirDesc,
    refFuellingListTable,
    dateStart,
    dateEnd,
    assetId,

    resolveUserRoleVariant,
    resolveUserRoleIcon,
    resolveUserStatusVariant,
    refetchData,

    //Extra Filters
    //roleFilter,
    //planFilter,
    //statusFilter,
  }
}
